export default {
  data() {
    return {
      cactusStrings: require('./cactus_strings.json')
    };
  },
  methods: {
    getCactusString(lngKey) {
      if (Array.isArray(lngKey) && lngKey.length > 1) {
        let str = this.$t((this.cactusStrings[lngKey[0]] || {}).web);
        return str.replace('%1$s%', lngKey[1]);
      }

      return this.$t((this.cactusStrings[lngKey] || {}).web);
    }
  }
};
